import { useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

export default function Login() {
  const { login, user } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to="/" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const r = await login(email, password);
    setBusy(false);
    if (!r.ok) toast.error(r.error || "Anmeldung fehlgeschlagen");
  };

  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-background px-4">
      <div className="w-full max-w-md">
        <div className="mb-8 flex items-center gap-3">
          <div className="h-10 w-10 rounded-md bg-primary flex items-center justify-center text-primary-foreground font-bold text-lg">S</div>
          <div>
            <h1 className="font-display text-2xl font-bold tracking-tight">Stellar Aufbereitung</h1>
            <p className="text-sm text-muted-foreground">Terminverwaltung · Frankfurt</p>
          </div>
        </div>

        <div className="border border-border/60 rounded-lg bg-card p-6">
          <h2 className="font-display text-xl font-semibold mb-1">Anmelden</h2>
          <p className="text-sm text-muted-foreground mb-6">Bitte melden Sie sich mit Ihren Zugangsdaten an.</p>

          <form onSubmit={submit} className="space-y-4">
            <div>
              <Label htmlFor="email">E-Mail</Label>
              <Input
                id="email"
                data-testid="login-email"
                type="email"
                autoComplete="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="kontakt@auto-stellar.de"
              />
            </div>
            <div>
              <Label htmlFor="password">Passwort</Label>
              <Input
                id="password"
                data-testid="login-password"
                type="password"
                autoComplete="current-password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
            <Button
              data-testid="login-submit"
              type="submit"
              className="w-full"
              disabled={busy}
            >
              {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Anmelden"}
            </Button>
          </form>
        </div>

        <p className="mt-6 text-xs text-center text-muted-foreground">
          © {new Date().getFullYear()} Stellar Aufbereitung
        </p>
      </div>
    </div>
  );
}
